import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { JwtDecodeService } from './jwtdecode.service';
import { LocalStorageService } from './localstorage.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./api.service";
import * as i3 from "./jwtdecode.service";
import * as i4 from "./localstorage.service";
import * as i5 from "ngx-permissions";
export class AuthService {
    constructor(router, api, jwtDecode, localStorage, permissionsService) {
        this.router = router;
        this.api = api;
        this.jwtDecode = jwtDecode;
        this.localStorage = localStorage;
        this.permissionsService = permissionsService;
        this.currentUserSubject = new BehaviorSubject({});
        this.currentUser = this.currentUserSubject
            .asObservable()
            .pipe(distinctUntilChanged());
        this.isAuthenticatedSubject = new BehaviorSubject(false);
        this.isAuthenticated = this.isAuthenticatedSubject.asObservable();
        this.loginUrl = 'portal/common/user/login';
    }
    registerUser(params, token) {
        params.token = token;
        return this.api.post('portal/common/user/signupUser', params).pipe(map((data) => {
            // this.setToken(data.token);
            // this.addRoles(data.token);
            // this.setUserAuthentication(data.user, this.addStoreId(data.token));
            return data;
        }));
    }
    attemptAuth(username, password) {
        const credentials = { userName: username, password: password };
        return this.api.post('portal/common/user/login', credentials).pipe(map((data) => {
            if (data.user) {
                data.user.idTenant = data.idTenant;
            }
            this.setToken(data.token);
            this.addRoles(data.token);
            this.setUserAuthentication(data.user, this.addStoreId(data.token), data.config);
            return data;
        }));
    }
    getBearerToken() {
        const token = this.localStorage.getItem('token');
        if (token) {
            return token;
        }
    }
    populateUser() {
        const token = this.getBearerToken();
        if (token) {
            this.setToken(token);
            this.addRoles(token);
            this.setUserAuthentication(this.getUserObject(), this.addStoreId(token));
        }
        else {
            this.removeUserAuthentication();
            // this.router.navigateByUrl('/portal/login');
        }
    }
    setUserAuthentication(user, storeId = null, config = null) {
        if (storeId)
            user.storeId = storeId;
        if (config)
            user.config = config;
        this.currentUserSubject.next(user);
        this.isAuthenticatedSubject.next(true);
        // this.isLoginAuthenticatedSubject.next(false);
        this.setUserObject(user);
    }
    removeUserAuthentication() {
        this.localStorage.clearItems();
        this.currentUserSubject.next({});
        this.isAuthenticatedSubject.next(false);
        // this.isLoginAuthenticatedSubject.next(true);
    }
    setToken(token) {
        this.localStorage.setItem('token', token);
    }
    removeToken() {
        this.localStorage.removeItem('token');
    }
    setUserObject(user) {
        this.localStorage.setItem('user', user);
    }
    getUserObject() {
        return this.localStorage.getItem('user');
    }
    addRoles(token) {
        this.permissionsService.flushPermissions();
        const rolesString = JSON.stringify(this.jwtDecode.decodeToken(token)['tags']);
        if (rolesString) {
            const rolesArray = JSON.parse(rolesString);
            for (const role of rolesArray) {
                this.permissionsService.addPermission(role);
                this.permissionsService.addPermission(role);
            }
        }
    }
    addStoreId(token) {
        return this.jwtDecode.decodeToken(token)['storeId'];
    }
    isLoggedIn() {
        return this.isAuthenticated;
    }
}
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.ApiService), i0.ɵɵinject(i3.JwtDecodeService), i0.ɵɵinject(i4.LocalStorageService), i0.ɵɵinject(i5.NgxPermissionsService)); }, token: AuthService, providedIn: "root" });
